var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _ellipse, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyIdIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.4109 29.766C83.1806 30.6225 84.7347 33.5634 83.8818 36.3347L72.1285 74.5208C71.1994 77.5385 67.8373 79.056 64.9593 77.757L36.209 64.7803L49.3968 20.1773L80.4109 29.766Z",
    fill: "white",
    stroke: "#1A0826",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9458 16.1474L81.7742 25.3695C84.5439 26.226 86.098 29.1669 85.245 31.9382L73.2579 70.8842C72.4049 73.6554 69.4679 75.2078 66.698 74.3516L36.8697 65.1295C36.2102 64.9256 35.8403 64.2254 36.0433 63.5656L50.384 16.973C50.5871 16.3131 51.2863 15.9435 51.9458 16.1474Z",
    fill: "#AA8FFF",
    stroke: "#1A0826",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9099 49.7314C65.1009 51.3398 70.61 48.4261 72.2149 43.2234C73.8197 38.0207 70.9125 32.4992 65.7214 30.8908C60.5304 29.2824 55.0213 32.1961 53.4165 37.3988C51.8117 42.6015 54.7189 48.123 59.9099 49.7314Z",
    stroke: "#1A0826",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7316 41.5239C64.7944 47.8041 59.9095 49.7308 59.9095 49.7308C59.9095 49.7308 56.9617 45.3772 58.8989 39.097C60.8361 32.8169 65.721 30.8902 65.721 30.8902C65.721 30.8902 68.6687 35.2438 66.7316 41.5239Z",
    stroke: "#1A0826",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9199 34.4238L72.6491 39.9171",
    stroke: "#1A0826",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9824 40.7041L70.7116 46.1974",
    stroke: "#1A0826",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8853 51.8574L47.8961 33.3307L7.66637 44.2131L12.6556 62.7399C13.2976 65.1239 15.7265 66.5402 18.0806 65.9034L49.7852 57.3271C52.1393 56.6903 53.5273 54.2414 52.8853 51.8574Z",
    fill: "#F3F3E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8961 33.3307C47.2541 30.9466 44.8252 29.5303 42.471 30.1671L10.7665 38.7434C8.41232 39.3802 7.02436 41.8291 7.66637 44.2131L47.8961 33.3307Z",
    fill: "#AA8FFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0806 65.9034L18.2753 66.6266L18.2753 66.6266L18.0806 65.9034ZM47.8961 33.3307L47.1731 33.5262L52.1623 52.053L52.8853 51.8574L53.6082 51.6618L48.619 33.1351L47.8961 33.3307ZM52.8853 51.8574L52.1623 52.053C52.6991 54.046 51.5369 56.0774 49.5904 56.6039L49.7852 57.3271L49.9799 58.0502C52.7417 57.3032 54.3555 54.4368 53.6082 51.6618L52.8853 51.8574ZM42.471 30.1671L42.6658 30.8902C44.6123 30.3637 46.6364 31.5332 47.1731 33.5262L47.8961 33.3307L48.619 33.1351C47.8717 30.3601 45.0381 28.6968 42.2763 29.4439L42.471 30.1671ZM10.7665 38.7434L10.5717 38.0203C7.80994 38.7673 6.19612 41.6337 6.94342 44.4087L7.66637 44.2131L8.38931 44.0176C7.85259 42.0245 9.0147 39.9931 10.9612 39.4666L10.7665 38.7434ZM49.7852 57.3271L49.5904 56.6039L17.8859 65.1803L18.0806 65.9034L18.2753 66.6266L49.9799 58.0502L49.7852 57.3271ZM18.0806 65.9034L17.8859 65.1803C15.9393 65.7068 13.9152 64.5373 13.3785 62.5443L12.6556 62.7399L11.9326 62.9354C12.6799 65.7104 15.5136 67.3737 18.2753 66.6266L18.0806 65.9034ZM12.6556 62.7399L13.3785 62.5443L8.38931 44.0176L7.66637 44.2131L6.94342 44.4087L11.9326 62.9354L12.6556 62.7399ZM7.66637 44.2131L7.86111 44.9363L48.0908 34.0538L47.8961 33.3307L47.7013 32.6075L7.47162 43.49L7.66637 44.2131ZM10.7665 38.7434L10.9612 39.4666L42.6658 30.8902L42.471 30.1671L42.2763 29.4439L10.5717 38.0203L10.7665 38.7434Z",
    fill: "#1A0826"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4673 53.6424L32.5248 50.1424L46.7728 46.2882L47.7153 49.7882L43.385 50.9596L44.3276 54.4596L34.4099 57.1424L33.4673 53.6424Z",
    fill: "#F3F3E0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4512 42.4424L43.442 38.9283L44.4223 42.5683L31.4314 46.0824L30.4512 42.4424Z",
    fill: "#F3F3E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4673 53.6424L32.5248 50.1424L46.7728 46.2882L47.7153 49.7882L43.385 50.9596M33.4673 53.6424L34.4099 57.1424L44.3276 54.4596L43.385 50.9596M33.4673 53.6424L43.385 50.9596M43.442 38.9283L30.4512 42.4424L31.4314 46.0824L44.4223 42.5683L43.442 38.9283Z",
    stroke: "#1A0826",
    strokeWidth: 1.49785,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.47296,
    cy: 3.47971,
    rx: 3.47296,
    ry: 3.47971,
    transform: "matrix(0.965307 -0.261124 0.260033 0.965598 15.709 45.7002)",
    fill: "#FFD7C8",
    stroke: "#1A0826",
    strokeWidth: 1.49785,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1905 61.8815L29.2594 58.6168C26.0884 53.2266 23.0885 50.914 20.8727 51.513C18.6567 52.1122 17.2249 55.6236 17.1905 61.8815Z",
    fill: "#AA8FFF",
    stroke: "#1A0826",
    strokeWidth: 1.49785,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6227 45.9933C20.4901 46.8135 18.9608 45.8883 18.4097 45.04C19.603 44.4152 21.6882 44.5549 22.6227 45.9933Z",
    fill: "#1A0826",
    stroke: "#1A0826",
    strokeWidth: 1.49785,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyIdIllustration);
export default __webpack_public_path__ + "static/media/VerifyIdIllustration.2719587905e916d8e69da1c51f948022.svg";
export { ForwardRef as ReactComponent };